import { Identifiable, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function removeTask(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Task>) =>
    httpClient
      .sendHttpRequest({
        endpoint: `/tasks/${uuid}`,
        method: HttpMethods.DELETE,
      })
      .then(() => Promise.resolve())
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            notFound: "notFound",
          }),
        ),
      );
}

export { removeTask };
